
<template>
  <div id="mithelfen">
      <PublicMenutop></PublicMenutop>
      <div class="row container" role="main">
        <div class="col">
 
            

<h1>Mit Whatsapp Ihrer Bücherei helfen</h1>

Sie möchten ein Cover (Bild eines Buchs, DVD, ...) einscannen das es in ihrer Bücherei nicht gibt. So geht es:

<ol>
<li><a href="#kontakt">Whatsapp-Kontakt einrichten</a></li>
<li><a href="#barcode">Barcode fotografieren und versenden</a></li>
<li><a href="#cover">Cover (Bild eines Buchs, DVD, ...) fotografieren und versenden</a></li>
</ol>


<a name="kontakt"></a>
<h1 style="margin-top: 40px">Whatsapp-Kontakt einrichten</h1>

<p>
Unsere Whatsapp-Telefonnummer ist:
</p>

<p>
<a href="https://wa.me/4915150794266">
<button type="button" class="btn btn-warning">Findus-Cover: 015150794266</button>
</a>
</p>

<p>
Nennen Sie den Kontakt am besten: Findus-Cover
</p>

<p>Niemand wird jemals an dieses Telefon gehen, dieses Telefon dient nur 
der Verarbeitung ihrer Büchereibilder. Sie werden keine Antwort erhalten.</p>




<a name="barcode"></a>
<h1 class="platznachoben">Barcode fotografieren und versenden</h1>

<img src="/mitmachen/barcode.jpg" style="float: left; padding-right: 40px; margin-top: 5px;">
<p>Das ist <b>das erste Bild</b>. Fotografieren Sie den Büchereibarcode möglichst groß. 
 Auf dem Barcode ist allermeistens der Name ihrer Bücherei zu erkennen. 
 Fotografieren Sie NICHT die EAN-Nummer, sondern den Strichcode ihrer Bücherei!</p>

<p>Nochmal:</p>
 <ul>
 <li>Erstes Bild</li>
 <li>Direkt in Whatsapp fotografieren</li>
 <li>KEIN Blitz, besser helles Zimmer</li>
 <li>Barcode der Bücherei</li>
 <li>NICHT die EAN-Nummer</li>
 </ul>

 <br clear="all">



<a name="cover"></a>
<h1 class="platznachoben">Cover fotografieren und versenden</h1>

<img src="/mitmachen/cover.jpg" style="float: left; padding-right: 40px; margin-top: 5px;">

<p>Das ist <b>das zweite Bild</b>. Fotografieren Sie das Medium von oben mit Rand. 
 Wir werden das Bild rechteckig ausschneiden. Der Hintergrund soll ein Tisch oder
 ein weißer Untergrund sein. Es soll hell im Zimmer sein.</p>

<p>Nochmal:</p>
  <ul>
  <li>Zweites Bild</li>
  <li>Direkt in Whatsapp fotografieren</li>
  <li>KEIN Blitz, besser helles Zimmer</li>
  <li>Von oben, nicht von der Seite oder schräg</li>
  <li>an allen Seiten Rand lassen</li>
  </ul>

  <p>
    <router-link to="/public/mithelfen/bildfehler">
    <a>Typische Bildfehler finden Sie hier aufgeführt mit Bildern...</a>
    </router-link>
  </p>


 <br clear="all">



<a name="nichtsweiter"></a>
<h1 class="platznachoben">Nichts weiter</h1>

<p>Wir werden</p>

<ul>
<li>nicht an dieses Telefon gehen</li>
<li>ihnen nicht antworten</li>
<li>nicht fragen wer sie sind</li>
<li>Sie nicht erfassen, registrieren oder irgendetwas zuschicken</li>
</ul>

<p>aber wir werden:</p>

<ul>
<li>Versuchen die Bilder so schnell wie möglich zu verarbeiten 
 und allen Büchereien zur Verfügung stellen die unsere Software benutzen
 um ihnen die Medien in der Bücherei zeigen wollen.</li>
</ul>

<p>
Wir wissen noch nicht wie wir reagieren sollen wenn Sie sich bemühen 
aber dauernd Fehler machen die die Bilder unbrauchbar machen. Wir denken darüber
nach. Bitte haben Sie etwas Geduld mit uns.
</p>


                </div>


              </div>
      
      <Footer></Footer>
  </div>
</template>

<script>
import PublicMenutop from '../../components/public/PublicMenutop.vue';
import Footer from '../../components/Footer.vue';
// kommt von pinegrow/bootstrap4:
import '../../components/sticky-footer-navbar.css';
import axios from 'axios';

// Mixin fuer diese Komponente importieren
import commonvars from '../mixins/commonvars.js';

export default {
  name: 'MithelfenWhatsapp',
  components: {
    PublicMenutop,
    Footer,
  },
  mixins: [
    commonvars
  ],
  data() {
    return {}
  },
  mounted: function() {
      this.statistik_einzelseite_updaten();
  },
  methods: {
    api_statistik_einzelseite_nickname() {
      return 'whatsapp';
    },
    api_statistik_einzelseite_url() {
        return this.server_base_url()
            + '/api/statistik/einzelseite/' + this.api_statistik_einzelseite_nickname();
    },
    statistik_einzelseite_updaten() {
      let url = this.api_statistik_einzelseite_url();

      axios.get(url)
      .then(
          () => {
              console.log("Update Statistik Einzelseite");
              
          }
      )
      .catch(
        () => {
            console.log("Fehler bei Update Statistik Einzelseite");
        }
      );
    }
  }
}

</script>

<style scoped>
a {
   text-decoration: underline;
}   
</style>


